import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { BasicDataSubService } from '../../../../shared/basic-data-management/basic-data-subservice.class';

import { HttpClient } from "@angular/common/http";

import { CachedDataSurveyService } from '../../../../technical-modules/tasks/services/cached-data-survey.service';

import { MotifRefus } from '../entities/motif-refus.entity';

@Injectable({ providedIn: 'root' })
export class MotifRefusService {
	private path: string;
	
	private motifRefusSubService!: BasicDataSubService<MotifRefus>;

	constructor( //
		@Inject(HttpClient) httpClient: HttpClient, //
		@Inject(CachedDataSurveyService) private cachedDataSurveyService: CachedDataSurveyService, //
		@Optional() @SkipSelf() previousInstance?: MotifRefusService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
		let motifsRefusChanged$ = this.cachedDataSurveyService.getChangeNotification("MotifRefus");
		this.motifRefusSubService = new BasicDataSubService<MotifRefus>(httpClient, this.path + 'acces/motifs_refus', motifsRefusChanged$);
	}

	// Methode permettant le chargement de toutes les agences
	public getList = () => this.motifRefusSubService.getList();

	// Methodes permettant le chargement de toutes les entites, selon differentes classifications et indexs
	// (NB: on procede a toutes les classifications en une fois, ce qui permet de n'iterer qu'une seule fois pour tous les resultats)
	public getMapById = () =>this.motifRefusSubService.getMapById();
	public getById = (id: number) => this.motifRefusSubService.getKnownById(id, "ParcTLR");
}